<script>
  export let title = "";
  export let description = "";
</script>

<h1
  class="uppercase mt-6 pb-2 text-4xl tracking-wider text-green-600 flex border-b border-gray-200"
>
  {title}
</h1>
<div class="text-gray-500 mt-4 mb-6 flex items-center">
  <i class="text-green-600 fas fa-info-circle mr-2" />
  {description}
</div>
